// extracted by mini-css-extract-plugin
module.exports = {"item":"ArticleCategories_item__pR0Rk","links":"ArticleCategories_links__OJJld"};